module.exports = __webpack_public_path__ + "img/s7.cabc48d1.png";